import * as React from 'react';
import { Treebeard, TreebeardNode } from 'react-treebeard';
import LoadingOverlay from './LoadingOverlay';
import HoverTooltip from './HoverTooltip';
import { userIsSystemAdmin } from '../../utilities/identity';
import SearchInputWithClear from './SearchWithClear';

export interface Props {
    cursor?: TreebeardNode;
    data: TreebeardNode[];
    isLoading: boolean;
    onClick: (node: TreebeardNode, toggled: boolean) => void;
    createCompany: () => void;
}

const addBusiness = require('../../images/add-business.png');

const TreeView = (props: Props) => {

    const [searchQuery, setSearchQuery] = React.useState('');
    const [filteredData, setFilteredData] = React.useState<TreebeardNode[]>(props.data);

    React.useEffect(() => {
        const filterTree = (node: TreebeardNode, query: string): TreebeardNode | null => {
            if (node.name.toLowerCase().includes(query.toLowerCase())) {
                return node;
            }
            if (node.children) {
                const filteredChildren = node.children
                    .map(child => filterTree(child, query))
                    .filter(Boolean) as TreebeardNode[];
                if (filteredChildren.length) {
                    return { ...node, children: filteredChildren };
                }
            }
            return null;
        };

        const filteredTreeData = props.data
            .map(node => filterTree(node, searchQuery))
            .filter(Boolean) as TreebeardNode[];

        setFilteredData(filteredTreeData);
    }, [searchQuery, props.data]);

    return (
        <div className="card tree-card">
            <LoadingOverlay show={props.isLoading} inBootstrapColumn={false} />

            {userIsSystemAdmin() ? (
                <div className="header tree-header has-buttons">
                    <button
                        id="mgmtCompanyBtn"
                        className="add-mgmt-company-btn"
                        onClick={props.createCompany}
                    >
                        <img src={addBusiness} />
                    </button>
                    <HoverTooltip targetId="mgmtCompanyBtn" text={'Add Management Company'} />
                </div>
            ) : (
                <div className="header tree-header" />
            )}

            <div className="card-body">
                <div>
                    <SearchInputWithClear
                        heading="Search..."
                        searchTerm={searchQuery}
                        setSearchTerm={setSearchQuery}
                    />
                    <div style={{ height: '20px' }}></div>
                    <Treebeard
                        data={filteredData}
                        onToggle={props.onClick}
                        style={{
                            tree: {
                                base: {
                                    listStyle: 'none',
                                    margin: 0,
                                    padding: 0,
                                    fontSize: '16px'
                                },
                                node: {
                                    base: {
                                        position: 'relative'
                                    },
                                    link: {
                                        cursor: 'pointer',
                                        position: 'relative',
                                        padding: '0px 5px',
                                        display: 'block'
                                    },
                                    activeLink: {
                                        background: 'lightgray'
                                    },
                                    toggle: {
                                        base: {
                                            position: 'relative',
                                            display: 'inline-block',
                                            verticalAlign: 'top',
                                            marginLeft: '-5px',
                                            marginTop: '-2px',
                                            height: '24px',
                                            width: '24px'
                                        },
                                        wrapper: {
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            margin: '-7px 0 0 -7px',
                                            height: '14px'
                                        },
                                        height: 16,
                                        width: 14,
                                        arrow: {
                                            fill: 'darkgray',
                                            strokeWidth: 0
                                        }
                                    },
                                    header: {
                                        base: {
                                            display: 'inline-block',
                                            verticalAlign: 'top'
                                        },
                                        connector: {
                                            width: '2px',
                                            height: '12px',
                                            borderLeft: 'solid 2px black',
                                            borderBottom: 'solid 2px black',
                                            position: 'absolute',
                                            top: '0px',
                                            left: '-21px'
                                        },
                                        title: {
                                            lineHeight: '24px',
                                            verticalAlign: 'middle'
                                        }
                                    },
                                    subtree: {
                                        listStyle: 'none',
                                        paddingLeft: '19px'
                                    },
                                    loading: {
                                        color: '#E2C089'
                                    }
                                }
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default TreeView;



// WEBPACK FOOTER //
// ./src/components/common/TreeView.tsx